export default __webpack_public_path__ + "static/media/ic-delete.2feb6727.svg";